export default __webpack_public_path__ + "static/media/Let it snow Christmas wreath.2a632fa5.jpg";